import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { VehicleModel, PagedResponseVehicleModel } from '../models/VehicleModel';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class VehicleModelService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getVehicleModels():Observable<PagedResponseVehicleModel>{
    const data =  this.http.get<PagedResponseVehicleModel>(this.APIURL+'/VehicleModel' + '?PageNumber=1&PageSize=5000');
    this.messageService.add('VehicleModel Service: fetched shops');
    return data;
  }

  getVehicleModel(id: number): Observable<VehicleModel> {
        const VehicleModel =this.http.get<VehicleModel>(this.APIURL+'/VehicleModel/' + id);
    this.messageService.add(`VehicleModel Service: fetched line with id=${id}`);
    return VehicleModel;
  }
}